import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getOrderGeneratorsFieldsWorksExecutorsBrigades: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES,
	},
	getOrderGeneratorsFieldsWorksExecutorsBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
	},
	createOrderGeneratorsFieldsWorksExecutorsBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
	},
	putOrderGeneratorsFieldsWorksExecutorsBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
	},
	patchOrderGeneratorsFieldsWorksExecutorsBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
	},
	deleteOrderGeneratorsFieldsWorksExecutorsBrigade: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES].DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE,
	},
}